import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import "./pRegistorModal.css";
import { MdClose } from "react-icons/md";
import swal from "sweetalert";

const P_RegistorModal = (props) => {

    const [name, setFullName] = useState();
    const [email, setEmail] = useState();
    const [location, setLocation] = useState();
    const [mobile, setMobile] = useState();

    const closeBookingModal = () => {
        props.setDisplayModal(false);
    };

    const RegisterClick = async (e) => {
        e.preventDefault();

        const pRegisterData = {
            name: name,
            email: email,
            location: location,
            mobile: mobile
        };
        try {

            let api = process.env.REACT_APP_URL + "photographer/set-photographer-request";
            console.log(api);
            console.log("https://api.fodrix.com/photographer/set-photographer-request");
            fetch(api, {
                method: "POST",
                body: JSON.stringify(pRegisterData),
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            })
                .then((response) => {

                    if (response.ok == true) {
                        swal("", "We will connect you shortly!", "success");
                    } else {
                        swal("", "Some thing went wrong!", "warning");
                    }
                    console.log(response)
                    return response.json();
                })
                .then((data) => {
                    console.log(data)
                })
                .catch((err) => {
                    console.log(err);
                    swal("", "Some thing went wrong!", "warning");
                })

        } catch (err) {
            console.log(err);
        }

    };

    return (
        <div className="modal_bg">
            <div className="p_register-container">
                <MdClose onClick={closeBookingModal} className="close-icon" />

                <div className="pResister_header">
                    <h3>Photographer Register</h3>
                </div>
                <form class="pRegister_form" onSubmit={RegisterClick}>
                    <div className="input-group">
                        <input
                            type="text"
                            placeholder="Full Name"
                            id="name"
                            onChange={(val) => {
                                setFullName(val.target.value);
                            }}
                            required
                        />
                        <input
                            type="text"
                            placeholder="Location"
                            id="location"
                            onChange={(val) => {
                                setLocation(val.target.value);
                            }}
                            required
                            list="option"
                        />
                        <datalist id="option">
                            <option value="Agartala"> Agartala </option>{" "}
                            <option value="Agra"> Agra </option>{" "}
                            <option value="Ahmedabad"> Ahmedabad </option>{" "}
                            <option value="Aizawl"> Aizawl </option>{" "}
                            <option value="Ajmer"> Ajmer </option>{" "}
                            <option value="Almora"> Almora </option>{" "}
                            <option value="Amaravati"> Amaravati </option>{" "}
                            <option value="Ambala"> Ambala </option>{" "}
                            <option value="Amritsar"> Amritsar </option>{" "}
                            <option value="Aurangabad"> Aurangabad </option>{" "}
                            <option value="Ayodhya"> Ayodhya </option>{" "}
                            <option value="Badrinath"> Badrinath </option>{" "}
                            <option value="Bangalore"> Bangalore </option>{" "}
                            <option value="Bhopal"> Bhopal </option>{" "}
                            <option value="Bhubaneswar"> Bhubaneswar </option>{" "}
                            <option value="Bikaner"> Bikaner </option>{" "}
                            <option value="Bilaspur"> Bilaspur </option>{" "}
                            <option value="Bodhgaya"> Bodhgaya </option>{" "}
                            <option value="Calangute, Goa"> Calangute, Goa </option>{" "}
                            <option value="Canacona, Goa"> Canacona, Goa </option>{" "}
                            <option value="Chandigarh"> Chandigarh </option>{" "}
                            <option value="Chennai"> Chennai </option>{" "}
                            <option value="Chittoor"> Chittoor </option>{" "}
                            <option value="Coimbatore"> Coimbatore </option>{" "}
                            <option value="Dalhousie"> Dalhousie </option>{" "}
                            <option value="Daman"> Daman </option>{" "}
                            <option value="Darjeeling"> Darjeeling </option>{" "}
                            <option value="Dehradun"> Dehradun </option>{" "}
                            <option value="Delhi"> Delhi </option>{" "}
                            <option value="Dharamshala"> Dharamshala </option>{" "}
                            <option value="Dwarka"> Dwarka </option>{" "}
                            <option value="Fatehpur Sikri"> Fatehpur Sikri </option>{" "}
                            <option value="Gandhinagar"> Gandhinagar </option>{" "}
                            <option value="Gangtok, Sikkim"> Gangtok, Sikkim </option>{" "}
                            <option value="Gurgaon"> Gurgaon </option>{" "}
                            <option value="Guwahati"> Guwahati </option>{" "}
                            <option value="Gwalior"> Gwalior </option>{" "}
                            <option value="Hampi"> Hampi </option>{" "}
                            <option value="Haridwar"> Haridwar </option>{" "}
                            <option value="Hyderabad"> Hyderabad </option>{" "}
                            <option value="Imphal"> Imphal </option>{" "}
                            <option value="Indore"> Indore </option>{" "}
                            <option value="Itanagar"> Itanagar </option>{" "}
                            <option value="Jabalpur"> Jabalpur </option>{" "}
                            <option value="Jaipur"> Jaipur </option>{" "}
                            <option value="Jaisalmer"> Jaisalmer </option>{" "}
                            <option value="Jammu"> Jammu </option>{" "}
                            <option value="Jhansi"> Jhansi </option>{" "}
                            <option value="Jodhpur"> Jodhpur </option>{" "}
                            <option value="Junagadh"> Junagadh </option>{" "}
                            <option value="Kanpur"> Kanpur </option>{" "}
                            <option value="Kasauli"> Kasauli </option>{" "}
                            <option value="Kavaratti"> Kavaratti </option>{" "}
                            <option value="Kedarnath"> Kedarnath </option>{" "}
                            <option value="Kohima"> Kohima </option>{" "}
                            <option value="Kolkata"> Kolkata </option>{" "}
                            <option value="Kufri"> Kufri </option>{" "}
                            <option value="Kullu"> Kullu </option>{" "}
                            <option value="Leh"> Leh </option>{" "}
                            <option value="Lucknow"> Lucknow </option>{" "}
                            <option value="Madurai"> Madurai </option>{" "}
                            <option value="Manali"> Manali </option>{" "}
                            <option value="Mangalore"> Mangalore </option>{" "}
                            <option value="Mathura"> Mathura </option>{" "}
                            <option value="Mumbai"> Mumbai </option>{" "}
                            <option value="Mussorie"> Mussorie </option>{" "}
                            <option value="Mysore"> Mysore </option>{" "}
                            <option value="Nagpur"> Nagpur </option>{" "}
                            <option value="Nainital"> Nainital </option>{" "}
                            <option value="Nashik"> Nashik </option>{" "}
                            <option value="Ooty"> Ooty </option>{" "}
                            <option value="Panaji, Goa"> Panaji, Goa </option>{" "}
                            <option value="Patna, Bihar"> Patna, Bihar </option>{" "}
                            <option value="Portblair"> Portblair </option>{" "}
                            <option value="Prayagraj"> Prayagraj </option>{" "}
                            <option value="Puducherry"> Puducherry </option>{" "}
                            <option value="Pune"> Pune </option>{" "}
                            <option value="Puri"> Puri </option>{" "}
                            <option value="Raipur"> Raipur </option>{" "}
                            <option value="Ranchi"> Ranchi </option>{" "}
                            <option value="Rourkela"> Rourkela </option>{" "}
                            <option value="Rishikesh"> Rishikesh </option>{" "}
                            <option value="Rohtak"> Rohtak </option>{" "}
                            <option value="Shillong"> Shillong </option>{" "}
                            <option value="Shimla"> Shimla </option>{" "}
                            <option value="Silchar"> Silchar </option>{" "}
                            <option value="Silliguri"> Silliguri </option>{" "}
                            <option value="Sonipat"> Sonipat </option>{" "}
                            <option value="Surat"> Surat </option>{" "}
                            <option value="Tawang"> Tawang </option>{" "}
                            <option value="Thiruvananthapuram"> Thiruvananthapuram </option>{" "}
                            <option value="Tirupati"> Tirupati </option>{" "}
                            <option value="Udaipur"> Udaipur </option>{" "}
                            <option value="Vadodara"> Vadodara </option>{" "}
                            <option value="Varanasi"> Varanasi </option>{" "}
                            <option value="Vijayawada"> Vijayawada </option>{" "}
                            <option value="Visakhapatnam"> Visakhapatnam </option>{" "}
                            <option value="Vrindavan"> Vrindavan </option>{" "}
                            <option value="Warangal"> Warangal </option>{" "}
                        </datalist>
                    </div>

                    <div className="input-group">
                        <input
                            type="email"
                            placeholder="Email"
                            id="email_register"
                            onChange={(val) => {
                                setEmail(val.target.value);
                            }}
                            required
                        />
                        <input
                            type="number"
                            placeholder="Mobile Number"
                            id="mobile_register"
                            onChange={(val) => {
                                setMobile(val.target.value);
                            }}
                            required
                        />
                    </div>

                    <div className="privacy_text">
                        By clicking on Register. I agree to Fodrix’s&nbsp;
                        <a href="/privacyPolicy">Privacy Policy </a>and
                        <a href="/tNc"> Terms and Conditions</a>.
                    </div>
                    <div class="p-form-group">
                        <button type="submit">Register</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default P_RegistorModal;
